export default "__VITE_ASSET__BbBIlTDm__"